import type { SVGProps } from 'react'
const SvgSyCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={24} height={24} {...props}>
		<path d="M464 256a208 208 0 1 0-416 0 208 208 0 1 0 416 0M0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0" />
	</svg>
)
export default SvgSyCircle
